import COLORS from "@/features/shared/widgets/graphs/colors";
import { lightBlue } from "@/theme/colors";

import type { PasquillClassLetter } from "./pasquill-classes";

/**
 * KNMI warning yellow (`--yellow` in theme.css). Same value as AVA's 30–40
 * band; the shared graph palette has no yellow, so it stays local here too.
 */
const KNMI_YELLOW = "#FFED00";

/**
 * Categorical fills per Pasquill class (PO): A red → F blue, matching the
 * AVA severity hues where they overlap (A–D) and KNMI blues for E–F.
 */
export const PASQUILL_CLASS_COLORS = {
  A: COLORS.POINTS.red,
  B: COLORS.POINTS.orange,
  C: KNMI_YELLOW,
  D: COLORS.POINTS.green,
  E: lightBlue,
  F: COLORS.POINTS.blue,
} as const satisfies Record<PasquillClassLetter, string>;

/** Yellow and light-blue fills are too pale for white lettering. */
const LIGHT_FILL_CLASSES = new Set<PasquillClassLetter>(["C", "E"]);

export function pasquillLabelColor(letter: PasquillClassLetter): string {
  return LIGHT_FILL_CLASSES.has(letter) ? "#3A3A3A" : "#FFFFFF";
}
